/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SealogExportRealAssetTracklineConfig = {
    type: SealogExportRealAssetTracklineConfig.type;
    /**
     *
     * Regular expression pattern to locate Sealog export files.
     *
     * Example: "Vehicles/Chimaera/{{parent_id}}/.*sealogExport.json"
     *
     */
    pattern: string;
    /**
     *
     * Identifier for the position data source within Sealog events.
     *
     * Common values:
     * - vehicleRealtimeNavData: Vehicle navigation data
     * - vehicleRealtimeHipapData: HiPAP position data
     *
     */
    data_source: string;
};

export namespace SealogExportRealAssetTracklineConfig {

    export enum type {
        SEALOG_EXPORT = 'sealog_export',
    }


}

